/**
 * @generated SignedSource<<46cdadd0229233d26bdb69dac8e719d4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PackageBillingType = "ONE_TIME" | "SUBSCRIPTION";
import { FragmentRefs } from "relay-runtime";
export type useGetBillingPeriod_memberPackage$data = {
  readonly id: string;
  readonly package: {
    readonly billingType: PackageBillingType;
  };
  readonly " $fragmentType": "useGetBillingPeriod_memberPackage";
};
export type useGetBillingPeriod_memberPackage$key = {
  readonly " $data"?: useGetBillingPeriod_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetBillingPeriod_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetBillingPeriod_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billingType",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "4b8390ed4354e0a256537a2d1ed5c3de";

export default node;
